var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"meetingsList",staticClass:"meetings-list-container",class:[
    `${
      _vm.widgetSettings.widget_style_settings.ew_events_list_view ===
      'progressive'
        ? _vm.eventsPorgressiveView === 'list'
          ? 'list'
          : 'grid'
        : _vm.widgetSettings.widget_style_settings.ew_events_list_view
    }-view-mode`,
  ]},[(_vm.pageSize !== 1)?_c('ListNotificationPanel'):_vm._e(),(
      _vm.windowSize !== 'mobile' &&
      ((_vm.widgetSettings.widget_style_settings.ew_events_list_view ===
        'progressive' &&
        !_vm.widgetSettings.widget_style_settings.show_filters_expanded) ||
        _vm.widgetSettings.widget_style_settings.ew_events_list_view !==
          'progressive') &&
      _vm.pageSize !== 1
    )?_c('EventsFilters'):_vm._e(),(
      _vm.widgetSettings.widget_style_settings.ew_events_list_view !==
        'progressive' &&
      _vm.windowSize !== 'mobile' &&
      _vm.pageSize !== 1
    )?_c('SelectedFiltersPanel'):_vm._e(),(_vm.pageSize !== 1)?_c('div',{staticClass:"list-metadata-container"},[_c('div',[(_vm.pageSize !== 1)?_c('SearchPanel',{staticClass:"list-metadata-location"}):_vm._e()],1),_c('div',{staticClass:"svv-list-controls-container"},[(
          !_vm.widgetSettings.widget_style_settings.ew_hide_view_mode_switch &&
          _vm.pageSize !== 1
        )?_c('EventsListViewModeSelector',{on:{"calendar-selected":_vm.fetchCalendarEvents}}):_vm._e(),_c('EventsListPageSizeSelector',{directives:[{name:"show",rawName:"v-show",value:(!_vm.collectionsMode && _vm.pageSize !== 1),expression:"!collectionsMode && pageSize !== 1"}],attrs:{"item-type":"event"}})],1)]):_vm._e(),(
      _vm.widgetSettings.widget_style_settings.ew_events_grid_fluid_mode &&
      ((_vm.widgetSettings.widget_style_settings.ew_events_list_view === 'grid' &&
        _vm.meetingsListForRender.length > 0 &&
        !_vm.isListLoading) ||
        (_vm.widgetSettings.widget_style_settings.ew_events_list_view ===
          'progressive' &&
          _vm.eventsPorgressiveView === 'grid') ||
        (_vm.widgetSettings.widget_style_settings.ew_events_list_view ===
          'category' &&
          !_vm.isListLoading &&
          _vm.meetingsListForRender.length > 0))
    )?_c('div',{directives:[{name:"masonry",rawName:"v-masonry",value:(_vm.eventsListMasonryParentContainerId),expression:"eventsListMasonryParentContainerId"}],ref:"eventsGridContainer",class:[
      `${
        _vm.widgetSettings.widget_style_settings.ew_events_list_view ===
        'progressive'
          ? _vm.eventsPorgressiveView === 'list'
            ? 'list'
            : 'grid'
          : _vm.widgetSettings.widget_style_settings.ew_events_list_view
      }-body-fluid`,
    ],attrs:{"transition-duration":"0.3s","item-selector":".svv-event-card-item.grid-layout-item","fit-width":"true","origin-left":"true"}},[_vm._l((_vm.meetingsListForRender),function(event,index){return _c('EventListCardItem',{key:index,attrs:{"list-view-mode":_vm.widgetSettings.widget_style_settings.ew_events_list_view ===
        'progressive'
          ? _vm.eventsPorgressiveView === 'list'
            ? 'list'
            : 'grid'
          : _vm.widgetSettings.widget_style_settings.ew_events_list_view,"event":event,"more-details-label":_vm.widgetSettings.widget_style_settings.event_more_details_label,"open-details-item":_vm.openDetailsItem,"shop-currency":_vm.widgetSettings.currency,"event-price":_vm.getEventPrice(event),"event-date-time":_vm.getEventDateTime(event),"on-show-more-details-click":_vm.onShowMoreDetailsClick,"on-book-event-click":_vm.onBookEventClick,"separator-data":_vm.getEventSeparatorData(event),"on-event-click":_vm.onEventClick}})}),_c('div',{directives:[{name:"waypoint",rawName:"v-waypoint",value:({
        active: true,
        callback: _vm.onListEnd,
        options: _vm.intersectionOptions,
      }),expression:"{\n        active: true,\n        callback: onListEnd,\n        options: intersectionOptions,\n      }"}],ref:"bottomLineEventsGridContainer"})],2):_vm._e(),(
      !_vm.widgetSettings.widget_style_settings.ew_events_grid_fluid_mode &&
      ((_vm.widgetSettings.widget_style_settings.ew_events_list_view === 'grid' &&
        _vm.meetingsListForRender.length > 0 &&
        !_vm.isListLoading) ||
        (_vm.widgetSettings.widget_style_settings.ew_events_list_view ===
          'progressive' &&
          _vm.eventsPorgressiveView === 'grid') ||
        (_vm.widgetSettings.widget_style_settings.ew_events_list_view ===
          'category' &&
          !_vm.isListLoading &&
          _vm.meetingsListForRender.length > 0))
    )?_c('div',{ref:"eventsGridContainer",class:[
      `${
        _vm.widgetSettings.widget_style_settings.ew_events_list_view ===
        'progressive'
          ? _vm.eventsPorgressiveView === 'list'
            ? 'list'
            : 'grid'
          : _vm.widgetSettings.widget_style_settings.ew_events_list_view
      }-body`,
    ]},[_vm._l((_vm.meetingsListForRender),function(event,index){return _c('EventListCardItem',{key:index,attrs:{"list-view-mode":_vm.widgetSettings.widget_style_settings.ew_events_list_view ===
        'progressive'
          ? _vm.eventsPorgressiveView === 'list'
            ? 'list'
            : 'grid'
          : _vm.widgetSettings.widget_style_settings.ew_events_list_view,"event":event,"more-details-label":_vm.widgetSettings.widget_style_settings.event_more_details_label,"open-details-item":_vm.openDetailsItem,"shop-currency":_vm.widgetSettings.currency,"event-price":_vm.getEventPrice(event),"event-date-time":_vm.getEventDateTime(event),"on-show-more-details-click":_vm.onShowMoreDetailsClick,"on-book-event-click":_vm.onBookEventClick,"separator-data":_vm.getEventSeparatorData(event),"on-event-click":_vm.onEventClick}})}),_c('div',{directives:[{name:"waypoint",rawName:"v-waypoint",value:({
        active: true,
        callback: _vm.onListEnd,
        options: _vm.intersectionOptions,
      }),expression:"{\n        active: true,\n        callback: onListEnd,\n        options: intersectionOptions,\n      }"}],ref:"bottomLineEventsGridContainer"})],2):_vm._e(),(
      _vm.widgetSettings.widget_style_settings.ew_events_list_view === 'list' ||
      (_vm.widgetSettings.widget_style_settings.ew_events_list_view ===
        'progressive' &&
        _vm.eventsPorgressiveView === 'list' &&
        !_vm.isListLoading &&
        _vm.meetingsListForRender.length > 0)
    )?_c('div',{class:[
      `${
        _vm.widgetSettings.widget_style_settings.ew_events_list_view ===
        'progressive'
          ? 'list'
          : _vm.widgetSettings.widget_style_settings.ew_events_list_view
      }-body`,
      `${
        _vm.widgetSettings.widget_style_settings.ew_events_list_view ===
          'progressive' && _vm.eventsPorgressiveView === 'list'
          ? 'svv-dynamic-list-height'
          : ''
      }`,
    ]},[_vm._l((_vm.meetingsListForRender),function(event,index){return _c('EventListCardItem',{key:index,attrs:{"list-view-mode":_vm.widgetSettings.widget_style_settings.ew_events_list_view ===
        'progressive'
          ? 'list'
          : _vm.widgetSettings.widget_style_settings.ew_events_list_view,"event":event,"more-details-label":_vm.widgetSettings.widget_style_settings.event_more_details_label,"open-details-item":_vm.openDetailsItem,"shop-currency":_vm.widgetSettings.currency,"event-price":_vm.getEventPrice(event),"event-date-time":_vm.getEventDateTime(event),"on-show-more-details-click":_vm.onShowMoreDetailsClick,"on-book-event-click":_vm.onBookEventClick,"separator-data":_vm.getEventSeparatorData(event),"on-event-click":_vm.onEventClick}})}),_c('div',{directives:[{name:"waypoint",rawName:"v-waypoint",value:({
        active: true,
        callback: _vm.onListEnd,
        options: _vm.intersectionOptions,
      }),expression:"{\n        active: true,\n        callback: onListEnd,\n        options: intersectionOptions,\n      }"}],ref:"bottomLineEventsGridContainer"})],2):_vm._e(),(
      _vm.widgetSettings.widget_style_settings.ew_events_list_view ===
        'calendar' && !_vm.isListLoading
    )?_c('div',{ref:"eventsCalendarContainer",class:[
      `${_vm.widgetSettings.widget_style_settings.ew_events_list_view}-body`,
    ]},[_c('EventsListCalendar',{attrs:{"attributes":_vm.getEventsAttributesForCalendar,"more-details-label":_vm.widgetSettings.widget_style_settings.event_more_details_label,"open-details-item":_vm.openDetailsItem,"shop-currency":_vm.widgetSettings.currency,"on-show-more-details-click":_vm.onShowMoreDetailsClick,"on-book-event-click":_vm.onBookEventClick,"on-event-click":_vm.onEventClick},on:{"month-change":_vm.onCalendarMonthChange}})],1):_vm._e(),_c('MeetingsPagination',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFilteredResultPaginationVisible && _vm.pageSize !== 1),expression:"isFilteredResultPaginationVisible && pageSize !== 1"}]}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"events-list-scrolling-marker",on:{"click":function($event){$event.preventDefault();return _vm.onMoreEventsClick.apply(null, arguments)}}},[_c('i',[_vm._v("❮")])]),(_vm.isListLoading && !_vm.isListEmpty)?_c('div',{staticClass:"list-loader"},[_vm._m(0)]):_vm._e(),(!_vm.isListLoading && _vm.isListEmpty && !_vm.isLoading)?_c('div',{staticClass:"svv-empty-events-list"},[_vm._v(" There are no items to display ")]):_vm._e(),_c('div',{staticClass:"list-result-counter-container"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(
        _vm.meetingsListForRender &&
        _vm.meetingsListForRender.length > 0 &&
        _vm.widgetSettings.widget_style_settings.ew_events_counter &&
        _vm.pageSize !== 1 &&
        !_vm.isLoading &&
        !_vm.isListLoading
      ),expression:"\n        meetingsListForRender &&\n        meetingsListForRender.length > 0 &&\n        widgetSettings.widget_style_settings.ew_events_counter &&\n        pageSize !== 1 &&\n        !isLoading &&\n        !isListLoading\n      "}]},[_vm._v(" "+_vm._s(_vm.meetingsListForRender.length)+" "+_vm._s(_vm.meetingsListForRender.length === 1 ? _vm.$t("mainWidget.singleEventItemsCounterLabel") : _vm.$t("mainWidget.itemsCounterLabel")))])])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"svv-loader center"},[_c('span')])
}]

export { render, staticRenderFns }